import { ITagSearch } from '@/client/legacy-shared-modules/search/search-types';

import { orderRecordsByIds } from '../../utils/contentHelpers';
import { SearchAIResults_TagsByIds_tagsByIds_results } from '../../graphql-types/SearchAIResults_TagsByIds';

export function mapTagsByIdsToTagHits(
  tags: SearchAIResults_TagsByIds_tagsByIds_results[],
  orderedTagIds: string[]
): ITagSearch[] {
  return orderRecordsByIds(tags, orderedTagIds).map((tag) => ({
    objectID: tag._id,
    name: tag.name?.trim() || 'Tag',
  }));
}
